import React from 'react';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';

const NoticeCard = ({
    whatWeCollect = [],
    description,
    legalBasis,
    whoWeShareItWith,
    userControl,
    expanded,
    onChange,
    icons = [] // New prop: an array of icons corresponding to whatWeCollect
}) => {

const cardStyle = {
    border: '1px solid #ccc',
    margin: '0px 0',
    padding: '0px',
    boxSizing: 'border-box', // This ensures padding and border are included in the total height
    overflow: 'auto'
    };

    const SmallCard = ({ label, Icon }) => {
        const smallCardStyle = {
            display: 'inline-flex',
            alignItems: 'center',
            padding: '8px 16px',
            margin: '4px',
            border: '1px solid #ccc',
            borderRadius: '4px',
            backgroundColor: '#f5f5f5',
            fontSize: '14px'
        };

        return (
            <span style={smallCardStyle}>
                {Icon && <Icon style={{ marginRight: '8px' }} />}
                {label}
            </span>
        );
    };


    return (
        <Accordion expanded={expanded} onChange={onChange} style={cardStyle}>
            <AccordionSummary
                expandIcon={<ExpandMoreIcon />}
                aria-controls="panel-content"
                id="panel-header"
            >
                <Typography sx={{ fontFamily: 'Manrope, sans-serif' }}>
                    {whatWeCollect.map((item, index) => (
                        <SmallCard key={item} label={item} Icon={icons[index]} />
                    ))}
                </Typography>
            </AccordionSummary>
            <AccordionDetails>
                <div style={{ width: '100%' }}>
                    <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif', marginBottom: '16px' }}>
                        <strong>Processing:</strong> {description}
                    </Typography>
                    <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif', marginBottom: '16px' }}>
                        <strong>Legal Basis:</strong> {legalBasis}
                    </Typography>
                    <Typography component="div" align="left" sx={{ fontFamily: 'Manrope, sans-serif', marginBottom: '16px' }}>
                        <strong>Who We Share It With:</strong> {whoWeShareItWith}
                    </Typography>
                </div>
            </AccordionDetails>
        </Accordion>
    );
};

export default NoticeCard;
